export default "__VITE_ASSET__DIRL4kD8__"